import { z } from 'zod'

export const accessSearchSchema = z.object({
  roleForm: z.enum(['new', 'edit']).optional().catch(undefined),
  roleId: z.coerce.number().optional().catch(undefined),
  adminForm: z.enum(['new', 'edit']).optional().catch(undefined),
  adminId: z.coerce.number().optional().catch(undefined),
})

export type AccessSearch = z.infer<typeof accessSearchSchema>
